<template>
  <img :src="this.img" alt="客服" @click="openCS">
</template>

<script>
export default {
  name: 'pictures',
  data () {
    return {
      img: require('../assets/customer-service.png')
    }
  },
  methods: {
    openCS () {
			const btn = document.getElementById('custom-service-btn')
			// API 不可用，触发按钮点击事件，让企点 DOM 型绑定的事件接管
			var event = new MouseEvent('click', {
					bubbles: true,
					cancelable: true,
					view: window
			})
			btn.dispatchEvent(event)
    }
  }
}
</script>

<style scoped>
img {
  position: fixed;
  right: 3rem;
  bottom: 4rem;
  width: 5rem;
  cursor: pointer;
}

@media screen and (max-width: 700px) {
  img {
    width: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerService.vue